import React, { useState } from "react";
import { useGetPOItems } from "../hooks";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Tooltip, IconButton } from "@mui/material";
import { Pagination, Search, Icon } from "semantic-ui-react";
import ListItemTabs from "./listItemTabs";
import Loader from "../../../../../../Global/Loader";
import { LibraryAddOutlined } from "@mui/icons-material";
import { ListItemMassiveUpdateModal } from "./listItemMassiveUpdateModal";
import { moduleActions } from "../../../../../../Global/Permission/constants";
import { validatePermission } from "../utils/validatePermission";
import { Button } from "reactstrap";
import Axios from "axios";
import { Services } from "../../../../../../../repositories/clients/Services";
import createModal from "../../../../../Components/ModalV2";
import { openNotification } from "../../../../../Components/Notification";

const ListItems = ({
  poId,
  t,
  lng,
  user,
  getPO,
  rolId,
  poStatus,
  FIELDS_WITHOUT_QUOTES,
  canEditItems,
}) => {
  const [disabledUpdate, setDisabledUpdate] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const {
    poItems,
    loading,
    error,
    handleExpand,
    handleEditItem,
    updatePOItem,
    handleSearch,
    handleUpdateStatus,
    massiveUpdate,
    parcedPOItem,
    page,
    totalPages,
    handleChangePage,
  } = useGetPOItems(poId, user, lng, refresh, rolId);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [modalConfirm, setModalConfirm] = useState(false);

  const handleSendErrorMessage = () => {
    openNotification("error", t("purchase_order_item_error_updated"));
  };

  const updateStatus = async (item, status) => {
    try {
      await handleUpdateStatus(item.POId, item.POItemsId, status);
      await getPO();
    } catch (error) {
      throw new Error(error);
    }
  };

  const updateParcedPOItem = async (id) => {
    try {
      await parcedPOItem(id);
      await getPO();
    } catch (error) {}
  };

  const updateItem = async (item) => {
    try {
      setDisabledUpdate(true);
      await updatePOItem(item);
      // await getPO();
      setDisabledUpdate(false);
      openNotification(
        "success",
        t("purchase_order_item_successfully_updated")
      );
    } catch (error) {
      handleSendErrorMessage();
    }
  };

  if (loading) return <Loader />;
  if (error) return `Error! ${error}`;

  const handleSearchChange = (e, { value }) => {
    setSearch(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e.target.value);
    }
  };

  const toggle = () => {
    setOpen(!open);
  };

  const update = async (values) => {
    try {
      let body = {
        POId: poId,
        ...values,
      };
      await massiveUpdate(body);
      await getPO();
    } catch (error) {
      throw error;
    } finally {
      setOpen(false);
    }
  };

  const handlePageChange = (e, { activePage }) => {
    handleChangePage(activePage);
  };

  function findPendingConfirmation(params) {
    let found = params[0]?.TotalWithStatus !== "0";
    return found;
  }

  const alertConfirm = () => {
    setModalConfirm(!modalConfirm);
  };

  async function confirmItems() {
    let body = { usr: user, poId: poId, rolId };
    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrder/posConfirmation`;
      await Axios.post(url, body);
      openNotification(
        "success",
        t("po_management_detail_confirm_items_success")
      );
      await getPO();
      setModalConfirm(false);
      setRefresh(!refresh);
    } catch (error) {
      console.log("🚀 ~ confirmItems ~ error:", error);
    }
  }

  return (
    <div className="listItemContainer col-12">
      <ListItemMassiveUpdateModal
        open={open}
        toggle={toggle}
        t={t}
        update={update}
        lng={lng}
        poStatus={poStatus}
        rolId={rolId}
        FIELDS_WITHOUT_QUOTES={FIELDS_WITHOUT_QUOTES}
      />
      <div className="listItemHeader row">
        <div className="col-xs-5 col-md-4 col-lg-5">
          <Search
            input={{
              icon: (
                <Icon
                  name="icon-search"
                  style={{
                    fontSize: "21px",
                    marginLeft: "-17px",
                    marginTop: "2px",
                  }}
                />
              ),
              iconPosition: "left",
              fluid: true,
              onKeyDown: handleKeyPress,
            }}
            placeholder={t("resume.itemsCollapse.searchPlaceholder")}
            value={search}
            open={false}
            name="search"
            onSearchChange={handleSearchChange}
          />
        </div>
        <div className="col-xs-7 col-md-8 col-lg-7 d-flex justify-content-end align-items-center">
          {canEditItems &&
          findPendingConfirmation(poItems) &&
          ["1", "8", "9"].includes(rolId) ? (
            <>
              <Tooltip
                title={
                  <label className="label-euro normal">
                    {t("po_management_detail_tooltip")}
                  </label>
                }
                arrow
              >
                <i className="icon-informative-tooltip custom-icon-tooltip yellow"></i>
              </Tooltip>
              <Button
                variant="contained"
                color="primary"
                style={{ maxWidth: "200px", width: "100%" }}
                className="ml-2 mr-2"
                onClick={() => {
                  alertConfirm();
                }}
                size="sm"
              >
                {t("po_management_detail_button_confirm_items")}
              </Button>
            </>
          ) : (
            false
          )}
          {poItems.length > 1 &&
            ![71, 74].includes(poStatus) &&
            canEditItems &&
            validatePermission(
              rolId,
              moduleActions.SUPPLIER_MANAGEMENT_MASSIVE_UPDATE
            ) && (
              <Tooltip
                title={
                  <label className="label-euro normal">
                    {t("resume.itemsCollapse.massiveUpdate")}
                  </label>
                }
                arrow
              >
                <IconButton onClick={toggle}>
                  <LibraryAddOutlined />
                </IconButton>
              </Tooltip>
            )}
        </div>
      </div>
      <div className="listItemContainerScroll">
        <div className="listItemContainerScrollWidth">
          <ListItemTabs
            poItems={poItems}
            handleExpand={handleExpand}
            handleEditItem={handleEditItem}
            handleUpdateStatus={updateStatus}
            parcedPOItem={updateParcedPOItem}
            updateItem={updateItem}
            t={t}
            error={error}
            lng={lng}
            rolId={rolId}
            disabledUpdate={disabledUpdate}
            FIELDS_WITHOUT_QUOTES={FIELDS_WITHOUT_QUOTES}
            canEditItems={canEditItems}
          />
        </div>
      </div>
      <div className="pagination-table">
        <Pagination
          totalPages={totalPages}
          activePage={page}
          onPageChange={handlePageChange}
          size="mini"
          siblingRange={0}
          ellipsisItem={null}
        />
      </div>

      {createModal({
        isModalOpen: modalConfirm,
        type: "success",
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{t("po_management_detail_confirm_items_alert")}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: t("No"),
            onClick: () => setModalConfirm(false),
            type: "secondary",
          },
          {
            text: t("yes"),
            onClick: () => confirmItems(),
            type: "primary",
          },
        ],
        onCancel: () => setModalConfirm(false),
      })}
    </div>
  );
};

export default withNamespaces()(withRouter(ListItems));
